import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { BarChart3, FileText, ChevronRight } from "lucide-react";
import { BackButton } from "../ui";
import apiClient from "../../utils/apiClient";
import { getCurrentUser } from "../../utils/auth";
import "./aiReport.scss";

function getScoreBg(score) {
  if (score >= 75) return "#10b981";
  if (score >= 50) return "#f59e0b";
  return "#ef4444";
}

function getGradeStyle(grade) {
  if (grade === "A+" || grade === "A") return { color: "#065f46", background: "#ecfdf5" };
  if (grade === "B+" || grade === "B") return { color: "#1e40af", background: "#eff6ff" };
  if (grade === "C") return { color: "#92400e", background: "#fffbeb" };
  return { color: "#991b1b", background: "#fef2f2" };
}

const AIReportHistory = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();
  const studentId = user?.studentId;

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!studentId) return;
    const fetchReports = async () => {
      try {
        const { data } = await apiClient.get(`/ai-report/student/${studentId}?limit=20`);
        setReports(data.reports || []);
      } catch {
        setReports([]);
      }
      setLoading(false);
    };
    fetchReports();
  }, [studentId]);

  if (loading) {
    return (
      <div className="air-page air-page--loading">
        <Spinner animation="border" variant="primary" />
        <span>Loading reports...</span>
      </div>
    );
  }

  return (
    <div className="air-history">
      <div className="air-history__header">
        <BackButton />
        <h1 className="air-history__title">
          <BarChart3 size={22} /> AI Report History
        </h1>
      </div>

      {reports.length === 0 ? (
        <div className="air-history__empty">
          <FileText size={40} />
          <p>No AI reports generated yet. Generate your first report from the dashboard.</p>
        </div>
      ) : (
        <div className="air-history__list">
          {reports.map((r) => (
            <div
              key={r._id}
              className="air-history__item"
              onClick={() => navigate(`/s/ai-report/${r._id}`)}
            >
              <div
                className="air-history__score-circle"
                style={{ backgroundColor: getScoreBg(r.overallScore) }}
              >
                {r.overallScore}
              </div>
              <div className="air-history__info">
                <h3>{r.courseInfo?.courseName || "Performance Report"}</h3>
                <p>
                  {new Date(r.generatedAt || r.createdAt).toLocaleDateString("en-IN", {
                    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
                  })}
                  {r.aiSummary && ` — ${r.aiSummary.substring(0, 80)}...`}
                </p>
              </div>
              <span className="air-history__grade" style={getGradeStyle(r.grade)}>
                {r.grade}
              </span>
              <ChevronRight size={18} color="#94a3b8" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AIReportHistory;
